@if (finishedLoading()) {
  <app-ui-dialog-shell [title]="dialogTitle">
    <p class="info">
      This will make <span class="bucket-name">{{ data.bucket.name }}</span> un-editable and hide it starting next
      month.
    </p>
    <form
      #archiveForm="ngForm"
      class="archive-bucket-dialog"
      (ngSubmit)="archiveBucket(balanceTransferBucket)"
      autocomplete="off"
    >
      @if (balance() !== 0) {
        <div>
          <p>
            There is a balance of
            <span [class.good]="balance() > 0" [class.bad]="balance() < 0">
              {{ balance() | currency: 'USD' : 'symbol' : '1.2-2' }}
            </span>
            left in <span class="bucket-name">{{ data.bucket.name }}</span
            >. Select a budget to transfer this balance.
          </p>
          <app-ui-field label="Transfer remaining balance to" [inputId]="'archive-bucket-transfer-target'">
            <select
              id="archive-bucket-transfer-target"
              appUiInput
              required
              [(ngModel)]="balanceTransferBucket"
              name="balanceTransferBucket"
            >
              <option [ngValue]="null" disabled>Select a budget</option>
              @for (bucket of availableBuckets(); track bucket.id) {
                <option [ngValue]="bucket.id">
                  {{ bucket.name }}
                </option>
              }
            </select>
          </app-ui-field>
        </div>
      }
      <div class="dialog-actions">
        <button appUiButton appearance="outline" tone="neutral" type="button" (click)="cancel()">Cancel</button>
        <button
          appUiButton
          tone="danger"
          type="submit"
          [disabled]="balance() !== 0 && (!archiveForm.form.dirty || !archiveForm.form.valid)"
        >
          Archive
        </button>
      </div>
    </form>
  </app-ui-dialog-shell>
} @else {
  <p aria-live="polite" class="archive-bucket-dialog__loading">Loading archive options...</p>
}
